export enum SituacaoOcorrencia {
  ATIVA = 'ATIVA',
  ENCERRADA = 'ENCERRADA',
  INUTILIZADA = 'INUTILIZADA',
  CANCELADA = 'CANCELADA',
}

export const SituacaoOcorrenciaOptions = [
  {value: SituacaoOcorrencia.ATIVA, label: 'Ativa'},
  {value: SituacaoOcorrencia.ENCERRADA, label: 'Encerrada'},
  {value: SituacaoOcorrencia.INUTILIZADA, label: 'Inutilizada'},
  {value: SituacaoOcorrencia.CANCELADA, label: 'Cancelada'},
];
